// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"725":"components-tabs","787":"index2"}[chunkId] || chunkId) + "." + {"725":"b45052b3","787":"96f4d1c6","876":"030ad2b5"}[chunkId] + ".css";
};